import API from "..";
import { API_MACHINE_IMPORT } from "../../constants/api";

async function importMachine(data) {
  const headers = {
    "Content-Type": "multipart/form-data",
  };

  try {
    const response = await API.post(API_MACHINE_IMPORT, data, {
      headers,
    });
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

export { importMachine };
